export const PageWrapper = ({ children, ...props }) => {
  return (
    <div id="db-wrapper" {...props}>
      {children}
    </div>
  )
}